<template>
  <div class="customer-info table-dark-bg box-shadow mt-2 p-3">
    <b-row>
      <b-col lg="6" md="6">
        <b-col lg="12">
          <label for class="mb-0" v-text="customerInfo.name"></label>
          <p v-text="customerInfo.mobile" />
          <!-- <button
          class="btn btn-danger btn-lg btn-block mt-4 mt-md-2"
          @click="$bvModal.show('lay_by_remove')"
          v-if="this.state.billing.layby_amount>0"
        >Untag Lay-by</button>-->

          <!-- <button
          class="btn btn-lg btn-block mt-4 mt-md-2"
          :disabled="checkLayBy"
          :class="
            state.billing.billing.layBy_Amt == 0
              ? 'btn-secondary'
              : 'btn-danger'
          "
          @click="addRemoveLayBy"
          v-if="
            state.billing.billing.invoice.data == '' &&
              state.billing.billing.order.data.transaction_sub_type == 'sales'
          "
        >-->
          <label for class="mb-0">Store Credit</label>
          <p class="mb-3">
            {{
              state.billing.billing.cart.hasOwnProperty("store_credit")
                ? currencySymbol +
                  formatAmount(state.billing.billing.cart.store_credit)
                : currencySymbol + "0.00"
            }}
          </p>
          <b-button
            class="mt-2"
            block
            id="tag-layby-btn"
            :disabled="layByStatus == true || checkLayBy || refundMode"
            :variant="
              state.billing.billing.layBy_Amt == 0 ? 'primary' : 'danger'
            "
            @click="addRemoveLayBy"
            v-if="
              state.billing.billing.invoice.data == '' &&
                state.billing.billing.order.data.transaction_sub_type ==
                  'lay_by'
            "
          >
            {{
              state.billing.billing.layBy_Amt == 0
                ? "Tag as Lay-by"
                : "Untag Lay-by"
            }}
          </b-button>
          <!-- <button
          :disabled="layByStatus == true || checkLayBy"
          class="btn btn-lg btn-block mt-4 mt-md-2 btn-danger"
          @click="addRemoveLayBy"
          v-if="state.billing.layBy_Amt != 0"
        >Untag Lay-by</button>-->

          <b-modal
            ref="lay_by"
            title="Tag as Lay-by"
            size="sm"
            centered
            id="lay_by"
            hide-footer
          >
            <b-form @submit.prevent>
              <!-- <header>
              <b-row class="mb-2">
                <b-col md="6">
                  <h6>Tag as Lay-by</h6>
                </b-col>
                <b-col md="6">
                  <font-awesome-icon
                    @click="$bvModal.hide('lay_by')"
                    class="float-right"
                    :icon="['fas', 'times']"
                  />
                </b-col>
              </b-row>
            </header>-->
              <b-row>
                <b-col md="6">Total Payable</b-col>
                <b-col offset="1">
                  <span
                    v-text="
                      currencySymbol +
                        formatAmount(
                          state.billing.billing.order.summary.total_payable
                        )
                    "
                  ></span>
                </b-col>
              </b-row>
              <hr />
              <b-form-group
                id="label-amt-layby"
                label="Enter amount for Lay-by"
                label-for="input-amt-layby"
              >
                <b-form-input
                  id="input-amt-layby"
                  type="number"
                  size="sm"
                  autofocus
                  placeholder="Enter Amount"
                  autocomplete="off"
                  @click="lay_by_input = ''"
                  v-model="lay_by_input"
                />
              </b-form-group>
              <!--<b-form-group class="pay" id="input-group-2" label="Remark" label-for="input-2">
              <b-form-textarea id="input-2" type="text" size="sm" autocomplete="off"></b-form-textarea>
            </b-form-group>-->
              <div class="clearfix"></div>
              <b-button
                type="submit"
                variant="primary"
                class="float-right mt-3"
                @click="saveLayBy()"
                :disabled="
                  lay_by_input == '' ||
                    lay_by_input >=
                      state.billing.billing.order.summary.total_payable
                "
                id="confirm-layby"
              >
                <span v-if="$loading == false">Confirm</span>
                <b-spinner small v-if="$loading == true"></b-spinner>
              </b-button>
              <!-- <b-button variant="danger" @click="closeCashModal">Cancel</b-button>-->
            </b-form>
          </b-modal>

          <!-- Remove layby -->
          <!-- <b-modal id="lay_by_remove" size="sm" hide-footer hide-header centered>
          <ul class="list-inline text-center">
            <li>
              <img src="../assets/images/alert.svg" class="text-center" alt />
            </li>
            <li>
              <p class="mb-4 mt-3">{{untagLayMsg}}</p>
            </li>
          </ul>

          <button class="btn btn-danger float-right px-4" @click="remove_layby()">
            <span v-if="$loading == false">Yes</span>
            <b-spinner small v-if="$loading == true"></b-spinner>
          </button>
          <button
            class="btn grey-outline-btn float-left px-4"
            @click="$bvModal.hide('lay_by_remove')"
          >Cancel</button>
        </b-modal>-->
        </b-col>
      </b-col>
      <b-col lg="6" md="6" class="">
        <label for class="mb-0">Account Balance</label>
        <p>
          {{ currencySymbol }}
          {{
            !checkOnAccountSale &&
            !transTypeDeposit &&
            !state.system.isOffline &&
            !state.billing.billing.order.data.trans_sub_type == "Credit-Note" &&
            !transTypeRefundNote
              ? formatAmount(state.billing.billing.on_account.customer_bal)
              : "0.00"
          }}
        </p>

        <b-modal
          ref="on_account_sale"
          :title="
            checkOnAccountLimit
              ? 'On-account sale'
              : parseFloat(state.billing.billing.on_account.max_limit) == 0
              ? 'Customer Limit Reached'
              : 'Insufficient Customer Limit'
          "
          size="md"
          centered
          id="on_account_sale"
          no-close-on-backdrop
          no-close-on-esc
        >
          <b-row class="py-3 customer-detail">
            <b-col md="6">
              <h6>Customer Number</h6>
              <p v-text="state.billing.billing.on_account.mobile"></p>
            </b-col>
            <b-col
              md="6"
              v-if="
                !checkOnAccountLimit &&
                  parseFloat(state.billing.billing.on_account.max_limit) == 0
              "
            >
              <h6>Account Balance</h6>
              <p
                class="text-danger"
                v-text="
                  currencySymbol +
                    formatAmount(state.billing.billing.on_account.customer_bal)
                "
              ></p>
            </b-col>
            <b-col
              md="6"
              v-if="parseFloat(state.billing.billing.on_account.max_limit) != 0"
            >
              <h6>Available Customer Limit</h6>
              <p
                :class="!checkOnAccountLimit ? 'text-danger' : null"
                v-text="
                  currencySymbol +
                    formatAmount(state.billing.billing.on_account.max_limit)
                "
              ></p>
            </b-col>
            <b-col md="6" class="mt-3" v-if="checkOnAccountLimit">
              <h6>Current Balance</h6>
              <p
                :class="
                  parseFloat(state.billing.billing.on_account.customer_bal) < 0
                    ? 'text-danger'
                    : null
                "
                v-text="
                  currencySymbol +
                    formatAmount(state.billing.billing.on_account.customer_bal)
                "
              ></p>
            </b-col>
            <b-col
              md="6"
              class="mt-3"
              v-if="
                checkOnAccountLimit &&
                  parseFloat(state.billing.billing.on_account.max_limit) != 0
              "
            >
              <h6>Balance after Sale</h6>
              <p
                :class="balAfterAccountSale < 0 ? 'text-danger' : null"
                v-text="currencySymbol + balAfterAccountSale"
              ></p>
            </b-col>
            <b-col
              md="6"
              class="mt-3"
              v-if="
                !checkOnAccountLimit &&
                  parseFloat(state.billing.billing.on_account.max_limit) != 0
              "
            >
              <h6>Current Bill Value</h6>
              <p v-text="currencySymbol + formatAmount(onAccountAmount)"></p>
            </b-col>
            <b-col
              md="6"
              class="mt-3"
              v-if="
                !checkOnAccountLimit &&
                  parseFloat(state.billing.billing.on_account.max_limit) != 0
              "
            >
              <h6>Minimum Payment Required</h6>
              <p
                v-text="
                  currencySymbol + formatAmount(minPayRequiredForAccountSale)
                "
              ></p>
            </b-col>
          </b-row>
          <b-form v-if="checkOnAccountLimit">
            <b-form-group
              id="label-amt-account-sale"
              label="Enter amount for On-account"
              label-for="input-amt-account-sale"
            >
              <b-form-input
                id="input-amt-account-sale"
                type="number"
                size="sm"
                autocomplete="off"
                placeholder="Enter amount for on-account"
                autofocus
                readonly
                v-model="onAccountAmount"
                @input="onAccountError = { show: false, message: '' }"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="pay"
              id="label-account-remark"
              label="Remark"
              label-for="input-account-remark"
            >
              <b-form-textarea
                id="input-account-remark"
                type="text"
                size="sm"
                autocomplete="off"
                :disabled="$loading"
                v-model="account_remark"
                no-resize
              ></b-form-textarea>
            </b-form-group>
            <p
              v-text="onAccountError.message"
              v-if="onAccountError.show"
              class="text-danger"
            ></p>
          </b-form>
          <p
            v-if="
              !checkOnAccountLimit &&
                parseFloat(state.billing.billing.on_account.max_limit) != 0
            "
            class="mt-4"
            v-text="
              'A mimimum payment of ' +
                currencySymbol +
                formatAmount(minPayRequiredForAccountSale) +
                ' is required to complete this on-account sale.'
            "
          ></p>
          <p
            v-if="
              !checkOnAccountLimit &&
                parseFloat(state.billing.billing.on_account.max_limit) == 0
            "
            class="mt-4"
            v-text="
              'Customer credit limit reached. On account sale is disabled till previous store debit notes are paid off.'
            "
          ></p>
          <template slot="modal-footer">
            <b-row>
              <b-col md="12" class="p-0 text-right">
                <b-button
                  v-if="checkOnAccountLimit"
                  variant="primary"
                  class="w-20"
                  :disabled="$loading"
                  @click="applyOnAccount"
                  id="confirm-account-sale"
                >
                  <span v-if="!$loading">Confirm</span>
                  <b-spinner small v-if="$loading" />
                </b-button>
                <b-button
                  v-else
                  class="grey-btn"
                  @click="$refs['on_account_sale'].hide()"
                  id="dismiss-account-sale"
                  >Dismiss</b-button
                >
              </b-col>
            </b-row>
          </template>
        </b-modal>

        <label for class="mb-0">Loyalty Points</label>
        <p class="mb-2" v-text="currencySymbol + '0.00'"></p>
      </b-col>
      <b-col lg="6" md="6" class="store_credit pr-1">
        <b-button
          class="mt-2"
          block
          :disabled="
            checkLayBy ||
              state.system.isOffline ||
              refundMode ||
              transTypeDeposit ||
              transTypeRefundNote ||
              isGvSale
          "
          :variant="state.billing.billing.layBy_Amt == 0 ? 'primary' : 'danger'"
          @click="addRemoveLayBy"
          v-if="layByCond"
          id="tag-layby-btn"
        >
          {{
            state.billing.billing.layBy_Amt == 0
              ? "Tag as Lay-by"
              : "Untag Lay-by"
          }}
        </b-button>
        <b-button
          class="mt-4 mt-md-2"
          variant="primary"
          block
          @click="openBox = true"
          :disabled="
            checkStoreCredit ||
              state.system.isOffline ||
              refundMode ||
              state.billing.billing.order.data.trans_sub_type ==
                'Credit-Note' ||
              transTypeRefundNote ||
              isGvSale
          "
          id="redeem-store-credit-btn"
        >
          Redeem Store Credit
        </b-button>
        <redeem-store-credit
          :open="openBox"
          @close-store="closeRedeemStoreModal"
        ></redeem-store-credit>
      </b-col>
      <b-col lg="6" md="6" class="pl-1">
        <b-row>
          <!-- <div class="col-2 justify-content-center d-flex align-items-center text-center">
            <a href="#">
              <font-awesome-icon :icon="['fas', 'pen']" size="1x" />
            </a>
          </div>-->
          <!-- <b-modal
            ref="loyalty-modal"
            hide-header
            id="loyalty-modal"
            hide-footer
            title="Loyalty Points"
            size="lg"
            @hide="closeLoyaltyModal"
            centered
          >
            <header>
              <b-row>
                <b-col md="6">
                  <h6>Loyalty Points</h6>
                </b-col>
                <b-col md="6">
                  <b-button
                    variant="danger"
                    v-model="closeLoyaltyModal"
                    class="float-right"
                    @click="$bvModal.hide('loyalty-modal')"
                  >Close</b-button>
                </b-col>
              </b-row>
            </header>
            <div class="d-block text-center">
              <iframe width="100%" height="400" id="loyaltyframe" :src="loyaltyURL" frameborder="0"></iframe>
            </div>
          </b-modal>-->
        </b-row>
        <b-button
          :disabled="
            checkOnAccountSale ||
              refundMode ||
              transTypeDeposit ||
              state.system.isOffline ||
              state.billing.billing.order.data.trans_sub_type ==
                'Credit-Note' ||
              transTypeRefundNote ||
              isGvSale ||
              ($store.getters.isOMSEnabled &&
                state.billing.billing.billing_mode == 'order')
          "
          class="mt-2"
          variant="primary"
          block
          id="on-account-sale-btn"
          @click="openAccountSale"
          >On-Account Sale</b-button
        >
        <b-button
          class="mt-4 mt-md-2"
          block
          variant="primary"
          :disabled="
            checkLoyalty ||
              state.system.isOffline ||
              refundMode ||
              transTypeRefundNote ||
              state.billing.billing.order.data.trans_sub_type ==
                'Credit-Note' ||
              isGvSale
          "
          @click="checkDeviceType"
          id="loyalty-btn"
        >
          Loyalty
        </b-button>
      </b-col>
    </b-row>
    <b-modal
      ref="redeem-type"
      hide-footer
      centered
      title="Redeem Loyalty"
      size="sm"
    >
      <p>Choose a method to redeem loyalty</p>
      <b-row class="mt-2 pl-3 pr-3 pt-2">
        <b-button @click="redeemLoyalty('COUPON')" id="redeem-coupon"
          >Coupon</b-button
        >
        <b-button
          @click="redeemLoyalty('LOYALTY')"
          class="ml-2"
          id="redeem-points"
          >Points</b-button
        >
      </b-row>
    </b-modal>
    <loyalty
      :isShow="isShow"
      :data="loyalty_url"
      v-on:hide-loyalty="hideLoyalty"
    />
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import RedeemStoreCredit from "../components/RedeemStoreCredit";
import * as msg from "../message";
import loyalty from "../views/Loyalty";

let windowOpen = "";
export default {
  name: "customer-info-checkout",
  components: {
    RedeemStoreCredit,
    loyalty,
  },
  props: ["amount"],
  data() {
    return {
      openBox: false,
      loyaltyURL: "",
      Allow_Point_Accrual: "",
      mobileno: "",
      redeemedpoints: "",
      redeemedvalue: "",
      referenceno: "",
      status: "",
      loading: false,
      lay_by_input: "",
      loyalityWindow: "",
      changeData: customData,
      layby_amount: "",
      checkLoyaltyType: "",
      isShow: false,
      loyalty_url: {},
      onAccountAmount: "",
      account_remark: "",
      onAccountError: { show: false, message: "" },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    customerInfo() {
      return this.$store.getters["billing/getCustomerDetails"];
    },
    checkLayBy() {
      if (this.state.system.settings.order.lay_by.status == 1) {
        return false;
      } else {
        return true;
      }
    },
    checkOnAccountSale() {
      let check = true;
      if (
        this.state.system.settings.vendor_app_menu.customer_logins.DEFAULT
          .options[0].on_account_sale.value == "mandatory"
      )
        check = false;
      this.state.billing.billing.order.summary.summary.forEach((element) => {
        if (element.name == "debit_voucher") check = true;
      });
      return check;
    },
    checkStoreCredit() {
      if (this.state.system.settings.cart.avail_offer.status == 1) {
        return false;
      } else {
        return true;
      }
    },
    checkLoyalty() {
      let check = true;
      let voucher = false;
      let coupon = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.mop_name == "loyalty_emr") {
          if (item.status == 1) {
            check = false;
            voucher = true;
            this.checkLoyaltyType = "LOYALTY";
          }
        } else if (item.mop_name == "coupon" && item.status == 1) {
          coupon = true;
          check = false;
          this.checkLoyaltyType = "COUPON";
        }
      });

      if (coupon == true && voucher == true) {
        this.checkLoyaltyType = "both";
      }

      return check;
    },
    layByStatus() {
      if (
        this.state.billing.billing.order.summary.amount_due != "0" ||
        parseInt(this.state.billing.billing.order.summary.amount_due != 0)
      ) {
        if (
          this.state.billing.billing.layBy_Amt != 0 ||
          this.state.billing.billing.layBy_Amt != ""
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    refundMode() {
      let check = false;
      if (this.state.billing.billing.refund_mode) {
        check = true;
      }
      return check;
    },
    // onAccountConfirmBtn() {
    //   let check = false;
    //   if (this.onAccountAmount == "" || parseInt(this.onAccountAmount) == 0)
    //     check = true;
    //   else if (
    //     parseFloat(this.onAccountAmount) >
    //     parseFloat(this.state.billing.billing.on_account.max_limit)
    //   )
    //     check = true;
    //   else if (
    //     parseFloat(this.onAccountAmount) >
    //     this.state.billing.billing.order.summary.total_payable
    //   )
    //     check = true;
    //   return check;
    // },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1 &&
        this.state.system.isOffline == false
      ) {
        check = true;
      }
      return check;
    },
    getOrderIdLength() {
      let length = this.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;
      return length;
    },
    transTypeDeposit() {
      return this.$store.getters["billing/checkIfTransTypeDeposit"];
    },
    checkOnAccountLimit() {
      let check = false;
      if (
        parseFloat(this.onAccountAmount) <=
        parseFloat(this.state.billing.billing.on_account.max_limit)
      )
        check = true;
      return check;
    },
    minPayRequiredForAccountSale() {
      return (
        parseFloat(this.onAccountAmount).toFixed(2) -
        parseFloat(this.state.billing.billing.on_account.max_limit).toFixed(2)
      ).toFixed(2);
    },
    balAfterAccountSale() {
      return parseFloat(
        parseFloat(this.state.billing.billing.on_account.customer_bal) -
          parseFloat(this.onAccountAmount)
      ).toFixed(2);
    },
    transTypeRefundNote() {
      let check = false;
      if (this.state.billing.billing.order.data.trans_sub_type == "Refund-CN")
        check = true;
      return check;
    },
    isGvSale() {
      return this.state.giftVoucher.isGvSale;
    },
    layByCond() {
      let temp = false;
      if (
        (this.state.billing.billing.invoice.data == "" &&
          this.state.billing.billing.order.data.transaction_sub_type == "") ||
        this.state.billing.billing.order.data.transaction_sub_type == "sales" ||
        this.state.billing.billing.order.data.transaction_sub_type == "order" ||
        this.state.billing.billing.order.data.transaction_sub_type ==
          "return" ||
        this.state.billing.billing.order.data.trans_sub_type == "Deposit-DN" ||
        this.state.billing.billing.order.data.trans_sub_type == "Credit-Note" ||
        this.state.billing.billing.order.data.trans_sub_type == "Refund-CN" ||
        this.isGvSale
      )
        temp = true;
      return temp;
    },
  },
  watch: {
    changeData: {
      handler(val) {
        let self = this;
        console.log("In Data");
        if (val.data.status == "loyalty_emr") {
          console.log("Change Data");
          if (val.data.type.status == "Success") {
            console.log("After Success");
            self.redeemedvalue = val.data.type.redeemedvalue;
            self.saveLoyalty(val.data.type);
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    let timer = setInterval(function() {
      if (windowOpen.closed) {
        console.log(windowOpen.source);
        clearInterval(timer);
        alert("closed");
      }
    }, 2000);
  },
  methods: {
    applyOnAccount() {
      this.$loading = true;
      let postData = {
        order_id: this.state.billing.billing.order.data.order_id,
        amount: this.onAccountAmount,
        type: "Debit",
        account_remark: this.account_remark,
        url: "/account-sale",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );

      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          if (res.data.status == "success") this.saveAccountSale();
          else if (res.data.status == "fail") {
            this.onAccountError = {
              show: true,
              message: res.data.message,
            };
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    openAccountSale() {
      this.onAccountAmount = this.amount;
      if (parseInt(this.state.billing.billing.on_account.allow_credit) == 1) {
        this.onAccountError = {
          show: false,
          message: "",
        };
        this.account_remark = "";
        this.$refs["on_account_sale"].show();
      } else {
        let alertData = {
          message: msg.ACCOUNT_SALE_NOT_AVAILABLE,
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      }
    },
    saveAccountSale() {
      this.$loading = true;
      let order_id = "";
      if (this.isOfflineEnabled) {
        order_id = this.state.billing.billing.invoice_no;
        console.log(order_id);
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }
      let postData = {
        amount: this.onAccountAmount,
        t_order_id: "",
        order_id: this.state.billing.billing.order.data.order_id,
        pay_id: "",
        method: "debit_voucher",
        invoice_id: "",
        bank: "",
        wallet: "",
        vpa: "",
        error_description: "",
        status: "success",
        address_id: "",
        payment_gateway_type: "ACCOUNT_DEBIT",
        cash_collected: "",
        cash_return: "",
        lay_by_total: "",
        lay_by_remark: "",
        transaction_sub_type: "",
        url: "save-payment",
        gateway_response: "",
        payment_gateway_device_type: "",
        invoice_seq: order_id,
        remark: this.state.billing.billing.remark,
        trans_type: "",
        credit_issue: "",
        type: this.transTypeDeposit ? "account_deposite" : "",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/savePayment", data)
        .then((res) => {
          this.$loading = false;
          if (
            this.state.billing.billing.total_payable == 0 ||
            this.state.billing.billing.total_payable == "0.00"
          ) {
            if (this.isOfflineEnabled) {
              this.$store.dispatch("billing/saveInvoiceId");
            }
            this.$store.commit("billing/resetBilling");
          }
          if (res.data.status == "validation") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
          this.$refs["on_account_sale"].hide();
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    checkDeviceType() {
      if (typeof Android !== "undefined" && Android !== null) {
        this.checkLoyaltyPoints();
      } else {
        this.checkRedeemType();
      }
    },
    addRemoveLayBy() {
      let tot_payable = this.state.billing.billing.order.summary.total_payable;
      if (this.state.billing.billing.layBy_Amt == 0) {
        this.$refs["lay_by"].show();
      } else if (this.state.billing.billing.layBy_Amt != 0) {
        this.$store.commit("billing/saveLaybyAmount", 0);
        this.$store.commit("billing/getTotalPayable", tot_payable);
        let alertData = {
          message: msg.LAY_BY_UNTAGGED,
          type: "success",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
        this.lay_by_input = "";
      }
    },
    saveLayBy() {
      this.layby_amount = this.state.billing.total_payable;
      this.$store.commit(
        "billing/saveLaybyAmount",
        parseFloat(this.lay_by_input)
      );
      // this.layby_amount = this.lay_by_input;
      this.$store.commit(
        "billing/getTotalPayable",
        parseFloat(this.lay_by_input)
      );
      this.$refs["lay_by"].hide();
      let alertData = {
        message: msg.LAY_BY_TAGGED,
        type: "success",
      };
      this.$showAlert = true;
      this.$store.commit("notifications/showAlert", alertData);
    },
    hideModal() {
      this.$refs["loyalty-modal"].hide();
    },
    closeRedeemStoreModal(data) {
      this.openBox = data;
    },
    checkRedeemType() {
      if (this.checkLoyaltyType == "both") {
        this.$refs["redeem-type"].show();
      } else {
        this.redeemLoyalty(this.checkLoyaltyType);
        // console.log(this.checkLoyaltyType);
      }
    },
    checkLoyaltyPoints() {
      this.$loading = true;
      let postData = {
        temp_order_id: this.state.billing.billing.cart.order_id,
        store_id: this.state.sessions.user.store_id,
        amount: this.state.billing.billing.total_payable,
        sub_total: this.state.billing.billing.subtotal,
        discount: this.state.billing.billing.discount,
        tax_total: this.state.billing.billing.taxes,
        total: this.state.billing.billing.total_payable,
        bill_buster_discount: "",
        employee_id: "",
        employee_discount: "",
        pay_by_voucher: "0.00",
        payment_gateway_type: "LOYALTY",
        bill_buster_id: "",
        manual_discount_factor: "",
        manual_discount_basis: "",
        manual_discount: "",
        transaction_sub_type: "",
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        url: "/process-to-payment",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then((res) => {
          if (typeof Android !== "undefined" && Android !== null) {
            let postData = {
              type: "loyalty_emr",
              data: res.data.loyalty_url,
            };
            returnValue(postData);
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    popupWindow(url, title, w, h) {
      let left = screen.width / 2 - w / 2;
      let top = screen.height / 2 - h / 2;
      return window.open(
        url,
        title,
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          top +
          ", left=" +
          left
      );
    },
    addLoyaltyPoints() {
      let postData = {
        amount: this.redeemedvalue,
        t_order_id: "",
        order_id: this.state.billing.billing.order.data.order_id,
        pay_id: this.referenceno,
        method: "cash",
        invoice_id: "",
        bank: "",
        wallet: "",
        vpa: "",
        error_description: "",
        status: "success",
        address_id: "",
        payment_gateway_type: "loyalty_emr",
        cash_collected: "",
        cash_return: "",
        lay_by_total: "",
        lay_by_remark: "",
        transaction_sub_type: "",
        url: "save-payment",
        payment_gateway_device_type: "",
        type: this.transTypeDeposit ? "account_deposite" : "",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/savePayment", data)
        .then(() => {
          this.$bvModal.hide("loyalty-modal");
          let redemptionRes = document.getElementById("redemptionResponse")
            .value;
          redemptionRes = JSON.parse(redemptionRes);
          redemptionRes.mobileno = this.mobileno;
          redemptionRes.redeemedpoints = this.redeemedpoints;
          redemptionRes.redeemedvalue = this.redeemedvalue;
          redemptionRes.referenceno = this.referenceno;
          redemptionRes.status = this.status;
          // console.log(this.redemptionRes);
        })
        .catch((err) => {
          console.log(err.response);
          this.$loading = false;
          // this.$bvModal.msgBoxOk(err.response.data.message);
        });
    },
    // closeLoyaltyModal() {
    // $bvModal.hide("loyalty-modal");
    // let data = $("#loyaltyframe").contents();
    // let data = document.getElementById("loyaltyframe");
    // let loyaltyValue = data.contentDocument.document.getElementById(
    //   "redemptionResponse"
    // ).value;
    // redemptionResponse
    // console.log(data);
    // },
    saveLoyalty(val) {
      let layby = "";
      if (this.layByStatus == true) {
        layby = "lay_by";
      }
      if (this.redeemedvalue != "") {
        let postData = {
          amount: this.redeemedvalue,
          t_order_id: "",
          order_id: this.state.billing.billing.order.data.order_id,
          pay_id: "",
          method: "loyalty_emr",
          invoice_id: "",
          bank: "",
          wallet: "",
          vpa: "",
          error_description: "",
          status: "success",
          address_id: "",
          payment_gateway_type: "LOYALTY",
          cash_collected: "",
          cash_return: "",
          lay_by_total: "",
          lay_by_remark: "",
          transaction_sub_type: "",
          url: "save-payment",
          gateway_response: JSON.stringify(val),
          payment_gateway_device_type: "",
          type: this.transTypeDeposit ? "account_deposite" : "",
        };
        let data = Object.assign(
          postData,
          this.essentialsData,
          this.customerData
        );
        this.$store
          .dispatch("billing/savePayment", data)
          .then(() => {
            this.$loading = false;
            if (
              this.state.billing.billing.total_payable == 0 ||
              this.state.billing.billing.total_payable == "0.00"
            ) {
              this.$store.commit("billing/resetBilling");
            }
            this.redeemedvalue = "";
          })
          .catch((err) => {
            console.log(err.response);
            this.$loading = false;
            // this.$bvModal.msgBoxOk(err.response.data.message);
          });
      }
    },
    redeemLoyalty(redeem_type) {
      this.$loading = true;
      this.$refs["redeem-type"].hide();
      let postData = {
        temp_order_id: this.state.billing.billing.cart.order_id,
        store_id: this.state.sessions.user.store_id,
        amount: this.state.billing.billing.total_payable,
        sub_total: this.state.billing.billing.subtotal,
        discount: this.state.billing.billing.discount,
        tax_total: this.state.billing.billing.taxes,
        total: this.state.billing.billing.total_payable,
        bill_buster_discount: "",
        employee_id: "",
        employee_discount: "",
        pay_by_voucher: "0.00",
        payment_gateway_type: redeem_type,
        bill_buster_id: "",
        manual_discount_factor: "",
        manual_discount_basis: "",
        manual_discount: "",
        transaction_sub_type: "",
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        url: "/process-to-payment",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : "",
      };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios.post(data.url, data).then((response) => {
        if (
          response.data.hasOwnProperty("loyalty_url") ||
          response.data.hasOwnProperty("coupon_url")
        ) {
          if (redeem_type == "LOYALTY") {
            this.loyalty_url.url = response.data.loyalty_url;
          } else if (redeem_type == "COUPON") {
            this.loyalty_url.url = response.data.coupon_url;
          }
          this.loyalty_url.type = redeem_type;
          this.isShow = true;
        } else {
          let alertData = {
            message: "Error: URL not found!",
            type: "danger",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
        }
        this.$loading = false;
      });
    },
    hideLoyalty() {
      if (this.isShow == true) {
        this.isShow = false;
        this.loyalty_url = {};
        console.log("[LOYALTY BOX: CLOSE]");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.theme-light .head {
  background-color: #c0c0c0;
  color: #fff;
  padding: 5px;
}
.theme-dark .head {
  background-color: #303030;
  color: #fff;
  padding: 5px;
}
.input input {
  background-color: #f4f4f4;
  padding: 7px 12px;
  border-radius: 5px;
  height: auto !important;
  text-align: center;
}
#success-popup .times {
  background: transparent !important;
  border: none;
  font-size: 16px;
  font-weight: 300;
}
.theme-dark #success-popup .times {
  color: #808080;
}
.theme-dark #success-popup button {
  color: #fff;
}
.theme-light .customer-info p {
  color: #000 !important;
  font-weight: 500;
}
.grey-btn {
  width: 110px;
}

.modal h6 {
  font-size: 0.8125rem;
  color: #606060;
  font-weight: 500;
}
.modal p {
  font-size: 0.9375rem;
  color: #606060;
  font-weight: 500;
  margin: 0px;
}
.modal .customer-detail {
  border-top: 1px #f0f0f0 solid;
  border-bottom: 1px #f0f0f0 solid;
  margin-bottom: 10px;
}
.modal input:read-only {
  background-color: transparent !important;
  border: 1px #c0c0c0 solid !important;
  color: #808080;
}
.store_credit {
  .btn-secondary {
    padding: 0.675rem 0rem !important;
  }
}
.modal p {
  font-size: inherit;
}
.modal-body button {
  padding: 0.475rem 1rem;
  width: 120px;
}
.theme-dark .modal-body p {
  color: #c0c0c0 !important;
}
.modal-body .grey-outline-btn {
  border: 1px #606060 solid;
  background-color: transparent !important;
  color: #606060;
  width: 120px;
}
.modal-body .grey-outline-btn:hover {
  background-color: #606060 !important;
  color: #fff;
}
</style>
